export default __webpack_public_path__ + "static/media/NG POINTS SIMULATOR IN ELECTRICAL WIRING.155ad677.JPG";